import type { SubtaskHash } from '@atlassian/jira-software-roadmap-model';
import type { State } from '../../types';

export const getFullSubtasksHash = (state: State): SubtaskHash => state.entities.subtasks.hash;
